import DOMPurify from 'dompurify';
import { createElement } from 'react';

const ALLOWED_TAGS = [
    'a',
    'b',
    'blockquote',
    'br',
    'code',
    'em',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'i',
    'li',
    'ol',
    'p',
    'pre',
    's',
    'span',
    'strong',
    'u',
    'ul',
];

export const sanitizeRichHTML = (html) => {
    return DOMPurify.sanitize(String(html || ''), {
        ALLOWED_TAGS,
        ALLOWED_ATTR: ['href', 'rel', 'target'],
        ALLOW_DATA_ATTR: false,
    });
};

const renderNode = (node, key) => {
    if (node.nodeType === 3) return node.textContent;
    if (node.nodeType !== 1) return null;

    const tagName = node.tagName.toLowerCase();
    const props = { key };
    if (tagName === 'a') {
        const href = node.getAttribute('href');
        const target = node.getAttribute('target');
        if (href) props.href = href;
        if (target) props.target = target;
        if (target === '_blank') props.rel = 'noopener noreferrer';
    }

    const children = Array.from(node.childNodes).map((child, index) => renderNode(child, `${key}-${index}`));
    return createElement(tagName, props, ...children);
};

export const renderSafeRichHTML = (html) => {
    const sanitizedHTML = sanitizeRichHTML(html);
    const parsedDocument = new DOMParser().parseFromString(sanitizedHTML, 'text/html');
    return Array.from(parsedDocument.body.childNodes).map((node, index) => renderNode(node, `rich-${index}`));
};
